import { axiosInstance } from "@/api/axiosInstance";
import {
  AddressApi,
  AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";
import { CustomAxiosRequestConfig } from "../types";

const api = new AddressApi(undefined, BASE_API, axiosInstance);

export const getAvailableAddress = async (
  payload: AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest
) => {
  return api.addonsViewsNinjaAddressListAvailableAddress.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};
